(function($){

	function initProductSpecs() {
        const labels = document.querySelectorAll(".product-specs-item__label");
        const tabs = document.querySelectorAll(".product-specs-tab");

        function toggleShow() {
            const target = this;
            const item = target.classList.contains("product-specs-tab") ? target : target.parentElement;
            const group = item.dataset.actabGroup;
            const id = item.dataset.actabId;

            tabs.forEach(function (tab) {
                if (tab.dataset.actabGroup === group) {
                    if (tab.dataset.actabId === id) {
                        tab.classList.add("product-specs-active");
                    } else {
                        tab.classList.remove("product-specs-active");
                    }
                }
            });

            labels.forEach(function (label) {
                const tabItem = label.parentElement;

                if (tabItem.dataset.actabGroup === group) {
                    if (tabItem.dataset.actabId === id) {
                        tabItem.classList.add("product-specs-active");
                    } else {
                        tabItem.classList.remove("product-specs-active");
                    }
                }
            });
        }

        labels.forEach(function (label) {
            label.addEventListener("click", toggleShow);
        });

        tabs.forEach(function (tab) {
            tab.addEventListener("click", toggleShow);
        });
        
        $( '.js-product-spec-slider' ).each( function() {
            $( this ).slick( {
                infinite: false,
                slidesToShow: 3,
                arrows: true,
                fade: false,
                slidesToScroll: 1,
//                prevArrow: $(this).parents('.image-slider').find('.image-slider-arrows-prev'),
//                nextArrow: $(this).parents('.image-slider').find('.image-slider-arrows-next'),
                responsive: [{
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 2
                    }
                },{
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1
                    }
                }]
            });
        });
        $( '.js-product-spec-image-slider' ).each( function() {
            $( this ).slick( {
                infinite: true,
                slidesToShow: 1,
                arrows: true,
                fade: true,
                slidesToScroll: 1
            });
        });
    }
    
       /* Document Ready */
	$(document).ready(function() {
        initProductSpecs();
	});
})(jQuery);